import {
  P0,
  S,
  abs,
  arc,
  fillAt,
  limb,
  max,
  quad,
  rotPts,
} from '../../geometry';

export const cherry = {
  name: 'Cherry',
  colors: ['#E5484D', '#2F9E5B'],
  draw(m, t) {
    let a1 = 3 * S(t * 1.3),
      a2 = 3 * S(t * 1.3 + 1.2),
      lf = 5 * S(t * 1.6),
      k = 1,
      pose = P0();
    if (m === 'happy') {
      a1 = 9 * S(t * 6);
      a2 = 9 * S(t * 6 - 1);
      lf = 20 * S(t * 9);
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: the pair keeps swinging on its stems, the small cherry a beat behind the big one.
    if (m === 'thinking') {
      a1 = 11 * S(t * 2.4);
      a2 = 13 * S(t * 2.4 - 1);
      lf = 12 * S(t * 2.4 + 1);
    }
    if (m === 'talking') {
      k = 1 + 0.06 * max(0, S(t * 10));
      a2 = 4 * S(t * 10);
    }
    if (m === 'surprised') {
      a1 = 5;
      a2 = -6;
      k = 1.06;
      lf = -18;
    }
    if (m === 'paused') {
      a1 = 2 + S(t * 0.6);
      a2 = -2;
      lf = 28;
      pose.ty = 2;
    }
    const J = [57, 15],
      sw = (p, a) => rotPts(p, J[0], J[1], a);
    const big = sw(arc(37, 66, 18.5 * k, -90, 270, 17), a1),
      small = sw(arc(73, 62, 12, -90, 270, 13), a2);
    const st1 = sw(quad([38, 48], [42, 24], J, 4), a1 * 0.6),
      st2 = sw(quad([72, 50], [69, 30], J, 4), a2 * 0.6);
    const leaf = [
      J,
      ...limb(J[0], J[1], -25 + lf, 17, 5, 4).slice(1),
      ...limb(J[0], J[1], -25 + lf, 17, -5, 4)
        .slice(1, 3)
        .reverse(),
      J,
    ];
    const eye = sw([[38, 66]], a1)[0];
    return {
      strokes: [
        { c: 'a', pts: small, n: 20 },
        { c: 'b', pts: st2 },
        { c: 'a', pts: big, n: 24 },
        { c: 'b', pts: st1 },
        { c: 'b', pts: leaf, n: 12 },
      ],
      eyes: { x: eye[0], y: eye[1] },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 2),
};
